import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { EditableSlotGroup, EditableToken, RichTextContent } from '@vibesites/runtime/react';
import { InnerPageHeroSubtitle } from './shared/InnerPageHeroSubtitle';
import {
  INNER_PAGE_HERO_TITLE_CLASS,
  InnerPageHeroSection,
} from './shared/InnerPageHeroSection';

const bgImageDef: SlotGroupDefinition = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Apply now banner',
    },
  },
};


export function ApplyNowHero() {
  return (
    <InnerPageHeroSection
      bgGroupPath="applynowhero.bg_image"
      bgImageDef={bgImageDef}
      altFallback="Apply now banner"
    >
      <InnerPageHeroSubtitle path="applynowhero.subtitle" />
      <RichTextContent
        path="applynowhero.title"
        as="h1"
        className={INNER_PAGE_HERO_TITLE_CLASS}
      />
      <EditableToken path="applynowhero.subtitle" type="richtext" as="span" className="hidden" style={{ display: 'none' }}>
        {''}
      </EditableToken>
      <EditableSlotGroup
        groupPath="applynowhero.bg_image"
        definition={bgImageDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </InnerPageHeroSection>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'ApplyNowHero',
  displayName: 'Apply Now Hero',
  tokens: {
    'applynowhero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: '<p>Apply Now</p>',
    },
    'applynowhero.subtitle': {
      label: 'Subtitle',
      type: 'richtext',
      defaultValue: '<p>Apply Online in <span data-type="field-token" data-field="property_address_city"></span>, <span data-type="field-token" data-field="property_address_state"></span></p>',
    },
  },
  slotGroups: {
    'applynowhero.bg_image': bgImageDef,
  },
};

(ApplyNowHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default ApplyNowHero;
